module.exports = __webpack_public_path__ + "img/cbc8724.svg";